/** Playable duration in timeline seconds */
export const getEffectiveDuration = ({ assetDuration, elementDuration, settingsStartTime = 0, settingsEndTime = 0, playbackRate = 1 }) => {
    const effectiveAssetDuration = getEffectiveVideoAssetDuration({
        assetDuration,
        settingsStartTime,
        settingsEndTime,
        elementDuration
    });
    return Math.min(effectiveAssetDuration / playbackRate, elementDuration);
};
/** Trimmed asset duration in media seconds */
export const getEffectiveVideoAssetDuration = ({ assetDuration, settingsStartTime = 0, settingsEndTime = 0 }) => {
    return settingsEndTime
        ? Math.min(settingsEndTime, assetDuration) - settingsStartTime
        : assetDuration - settingsStartTime;
};
/** Next playback-count boundary in timeline seconds */
export const getVideoEndTime = ({ progressTime, effectiveAssetDuration, playbackRate = 1 }) => {
    if (effectiveAssetDuration <= 0) {
        return 0;
    }
    const timelinePlaythroughDuration = effectiveAssetDuration / playbackRate;
    const videoPlaybackCount = Math.floor(progressTime / timelinePlaythroughDuration);
    return (videoPlaybackCount + 1) * timelinePlaythroughDuration;
};
/** Media-seconds offset into the asset after one element window has elapsed */
export const getNextOffset = ({ elementDuration, effectiveAssetDuration, videoOffset, playbackRate = 1 }) => {
    return (elementDuration * playbackRate + videoOffset) % effectiveAssetDuration;
};
/** Media position for the current progress; `progressTime` and `effectiveDuration` are timeline seconds */
export const getVideoStartTime = ({ progressTime, settingsStartTime, effectiveDuration = 0, isVideoLooped = false, playbackRate = 1 }) => {
    if (effectiveDuration <= 0) {
        return settingsStartTime;
    }
    if (!isVideoLooped) {
        return settingsStartTime + Math.min(progressTime, effectiveDuration) * playbackRate;
    }
    const restOfVideoToPlay = progressTime % effectiveDuration;
    return settingsStartTime + restOfVideoToPlay * playbackRate;
};
